import React from 'react';
import './index.module.scss';
import styles from '../attempts-exhausted/index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const GeoresctrictionScreen = ({ setScreenNumber, telegramLink }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <HeadContainer
        setScreenNumber={setScreenNumber}
        customTelegramLink={telegramLink}
        telegramOnly
      />
      <div className={styles.content}>
        <p className={styles.title}>УПС:(</p>
        <p className={styles.description}>
          Даний контент доступний виключно на території України.
        </p>
      </div>
    </div>
  );
};

export default GeoresctrictionScreen;
